import { render, staticRenderFns } from "./ResourcesListCard.vue?vue&type=template&id=118c50d5&scoped=true"
import script from "./ResourcesListCard.vue?vue&type=script&lang=ts"
export * from "./ResourcesListCard.vue?vue&type=script&lang=ts"
import style0 from "./ResourcesListCard.vue?vue&type=style&index=0&id=118c50d5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c50d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118c50d5')) {
      api.createRecord('118c50d5', component.options)
    } else {
      api.reload('118c50d5', component.options)
    }
    module.hot.accept("./ResourcesListCard.vue?vue&type=template&id=118c50d5&scoped=true", function () {
      api.rerender('118c50d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ResourcesListCard.vue"
export default component.exports